import { Podcast, PodcastSection, PodcastSectionActor } from '../types';

import avatar1 from '../Generate/Modal/View/Podcast/SpeakersSelect/assets/alex.png'
import avatar2 from '../Generate/Modal/View/Podcast/SpeakersSelect/assets/mary.png'

export const generatePodcast = (): Podcast => {
  const actors: PodcastSectionActor[] = [
    {
      avatar: avatar1,
      name: 'Speaker 1',
      text: 'Speaker 1 text',
    },
    {
      avatar: avatar2,
      name: 'Speaker 2',
      text: 'Speaker 2 text',
    },
  ]

  const sections: PodcastSection[] = [
    {
      title: 'Intro',
      start: 0,
      actors,
    },
    {
      title: 'Section 2',
      start: 10,
      actors,
    },
    {
      title: 'Section 3',
      start: 24,
      actors,
    },
    {
      title: 'Section 4',
      start: 30,
      actors,
    },
    {
      title: 'Section 5',
      start: 36,
      actors,
    },
    {
      title: 'Section 6',
      start: 42,
      actors,
    },
  ]

  const podcast: Podcast = {
      audio: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
      title: 'Podcast Title',
      summary: 'Podcast Summary',
      sections,
  };

  return podcast;
}
